import { AccordionDetails, Fab, styled, Tabs } from '@mui/material';

export const StyledTabs = styled(Tabs)({
    root: {
        borderBottom: '1px solid #e8e8e8'
    },
    indicator: {
        backgroundColor: '#1890ff'
    }
});

export const LessRoundedFab = styled(Fab)({
    root: {
        borderRadius: '6px',
        width: '40px',
        height: '36px'
    }
});

export const TightAccordionDetails = styled(AccordionDetails)({
    root: {
        marginTop: '0',
        padding: '0'
    }
});
